module.exports = __webpack_public_path__ + "static/media/rectangle_black_mob.860fa271.svg";